import React, { useEffect, useState } from 'react'
import { Card, CardBody, CardHeader, CardHeaderToolbar } from '../../../../_metronic/_partials/controls'
import Table, { dateFormatter, buttonsStyle } from '../../../components/tables/table'
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog'
import {
  getCampaigns,
  deleteCampaign,
  sendCampaign,
  cancelScheduleCampaign,
} from '../../../../api/push'
import { Button, Tooltip } from '@material-ui/core'
import DeleteIcon from '@material-ui/icons/Delete'
import EditIcon from '@material-ui/icons/Edit'
import SendIcon from '@material-ui/icons/Send'
import CancelScheduleIcon from '@material-ui/icons/EventBusy'
import { alertError, alertSuccess } from '../../../../utils/logger'
import { useHistory } from 'react-router-dom'

const AUDIENCE = { turistas: 'Turistas', residentes: 'Ciudadanos', todos: 'Todos' }

const STATUS_LABEL = {
  draft: 'Borrador',
  scheduled: 'Programada',
  sending: 'Enviando',
  sent: 'Enviada',
  failed: 'Fallida',
}

function getData(items) {
  return items.map((c) => ({
    id: c._id,
    title: c.title,
    audience: AUDIENCE[c.audience] || c.audience,
    status: STATUS_LABEL[c.status] || c.status,
    scheduledAt: c.scheduledAt,
    sentAt: c.sentAt,
    createdAt: c.createdAt,
  }))
}

export default function PushPage() {
  const [data, setData] = useState([])
  const [campaignId, setCampaignId] = useState(null)
  const [openConfirmDialog, setOpenConfirmDialog] = useState(null)
  const [refresh, setRefresh] = useState(false)
  const history = useHistory()

  function buttonFormatter(cell) {
    const row = data.find((c) => c._id === cell)
    const canSend = row?.status === 'draft' || row?.status === 'scheduled' || row?.status === 'failed'
    const canCancel = row?.status === 'scheduled'
    return (
      <>
        <Tooltip title="Ver / editar">
          <Button style={buttonsStyle} size="small" onClick={() => history.push('/edit-push/' + cell)}>
            <EditIcon />
          </Button>
        </Tooltip>
        {canSend && (
          <Tooltip title="Enviar ahora">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={() => {
                setCampaignId(cell)
                setOpenConfirmDialog(1)
              }}
            >
              <SendIcon />
            </Button>
          </Tooltip>
        )}
        {canCancel && (
          <Tooltip title="Cancelar programación">
            <Button
              style={buttonsStyle}
              size="small"
              onClick={() => {
                setCampaignId(cell)
                setOpenConfirmDialog(3)
              }}
            >
              <CancelScheduleIcon />
            </Button>
          </Tooltip>
        )}
        <Tooltip title="Eliminar">
          <Button
            style={buttonsStyle}
            size="small"
            onClick={() => {
              setCampaignId(cell)
              setOpenConfirmDialog(2)
            }}
          >
            <DeleteIcon />
          </Button>
        </Tooltip>
      </>
    )
  }

  const columns = [
    { dataField: 'title', text: 'Título', sort: true },
    { dataField: 'audience', text: 'Audiencia', sort: true },
    { dataField: 'status', text: 'Estado', sort: true },
    { dataField: 'scheduledAt', text: 'Programada', formatter: dateFormatter, sort: true },
    { dataField: 'sentAt', text: 'Enviado', formatter: dateFormatter, sort: true },
    { dataField: 'createdAt', text: 'Creado', formatter: dateFormatter, sort: true },
    { dataField: 'id', text: '', formatter: buttonFormatter },
  ]

  useEffect(() => {
    getCampaigns()
      .then((res) => {
        if (res.status === 200) {
          setData(res.data)
          setRefresh(false)
        }
      })
      .catch((error) => {
        alertError({ error, customMessage: 'No se pudieron cargar las campañas.' })
      })
  }, [refresh])

  return (
    <Card>
      <CardHeader title="Notificaciones push">
        <CardHeaderToolbar>
          <button type="button" className="btn btn-primary" onClick={() => history.push('/edit-push')}>
            Nueva campaña
          </button>
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <Table data={getData(data)} columns={columns} />
        <ConfirmDialog
          title="¿Enviar esta notificación ahora?"
          open={openConfirmDialog === 1}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            sendCampaign(campaignId)
              .then((res) => {
                if (res.status === 200) {
                  alertSuccess({ title: 'Enviada', customMessage: 'Campaña enviada.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo enviar.' })
              })
          }}
        />
        <ConfirmDialog
          title="¿Eliminar esta campaña?"
          open={openConfirmDialog === 2}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            deleteCampaign(campaignId)
              .then((res) => {
                if (res.status === 200 || res.status === 204) {
                  alertSuccess({ title: 'Eliminada', customMessage: 'Campaña eliminada.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo eliminar.' })
              })
          }}
        />
        <ConfirmDialog
          title="¿Cancelar la programación? La campaña pasará a borrador."
          open={openConfirmDialog === 3}
          setOpen={setOpenConfirmDialog}
          onConfirm={() => {
            cancelScheduleCampaign(campaignId)
              .then((res) => {
                if (res.status === 200) {
                  alertSuccess({ title: 'Cancelada', customMessage: 'Programación cancelada.' })
                  setRefresh(true)
                }
              })
              .catch((error) => {
                alertError({ error, customMessage: 'No se pudo cancelar.' })
              })
          }}
        />
      </CardBody>
    </Card>
  )
}
